import { useState, useEffect } from 'react';
import { getMyPizzeria } from '../services/api';

const useMyPizzeria = () => {
  const [pizzeriaData, setPizzeriaData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMyPizzeria = async () => {
    try {
      const response = await getMyPizzeria();
      const {data, status} = response;
      if (status === 200) {             
        setPizzeriaData(data);
      } else if (status === 204) {
        setPizzeriaData({});
      } else {              
        throw new Error('Failed to fetch pizzeria data');
      }
    } catch (error) {      
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const savePizzeriaData = async (formData) => {
    const method = pizzeriaData && pizzeriaData.id ? 'PUT' : 'POST';
    const endpoint = pizzeriaData && pizzeriaData.id ? `/pizzeria/${pizzeriaData.id}` : '/pizzeria';
    
    try {
      const response = await fetch(endpoint, {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      if (!response.ok) {
        throw new Error('Failed to save pizzeria');
      }
      const updatedData = await response.json();
      setPizzeriaData(updatedData);
      return updatedData;
    } catch (error) {
      setError(error);
      throw error;
    }
  };

  useEffect(() => {
    fetchMyPizzeria();
  }, []);

  return { pizzeriaData, loading, error, savePizzeriaData };
};

export default useMyPizzeria;
